export default {
    "transactions_title": "Transaction Summary",
    "transactions_customer": "Customer",
    "transactions_status": "Status",
    "transactions_error": "Error",
    "transactions_refresh": "Refresh",
}